module.exports = __webpack_public_path__ + "img/norfolk-island.3527e163.png";